import { call, takeLatest } from "redux-saga/effects";
import {
  ACQ_SRC_LIST,
  ADMIN_ROLES,
  BANK_NAME_LIST,
  BUISNESS_TYPE_LIST,
  CATEGORY_LIST,
  CUSTOMER_TYPE_LIST,
  BIN_LOCATION_LIST,
  DEFAULT_BIN_LOCATION,
  SEARCH_BIN_LOCATION,
  CUSTOMER_LIST,
  DEPARTMENR_LIST,
  DIS_CUS_GROUP_LIST,
  DIS_CUS_CAT_LIST,
  DIS_CUS_LIST,
  DOCTOR_LIST,
  IMAGE_UPLOAD,
  ITEM_GROUP_LIST,
  ITEM_TYPE_DROP_DOWN,
  MANUFACTURERS_LIST,
  PAYMENT_METHODS_LIST,
  PHONE_LIST,
  PINCODE_LIST,
  GST_SEARCH_TAXPAYER,
  MANUFACTURER_FUZZY_SEARCH,
  PRICE_LIST,
  PRODUCT_DETAILS,
  PRODUCT_LIST,
  ROLES_LIST,
  SCH_LIST,
  SECTOR_LIST,
  SHIPPING_TYPE_LIST,
  STATE_LIST,
  STORE_ID,
  TAX_CAT_LIST,
  TRANSACTION_PRINT,
  TRANSACTION_SHARE,
  UOM_GROUP_FIND_ONE,
  UOM_GROUP_LIST,
  UOM_LIST,
  USERS_LIST,
  VALUATION_LIST,
  VENDOR_LIST,
  WARE_HOUSE_LIST,
  STORE_LIST,
  DOC_LIST,
  ADMIN_ROLES_MOD,
  PRODUCT_BATCH_DETAILS,
  STORE_STATE_LIST,
  STORE_DISTRICT_LIST,
  STORE_CITY_LIST,
  STORE_SEARCH,
  STORE_ITEM,
  STORE_ITEM_PARAMED,
  TABLE_ALERT,
  COLUMN_ALERT,
  ALL_USERS_LIST,
  ATTACHED_ROLES_DEPARTMENT_LIST,
  GET_ADDRSS,
  WARE_HOUSE_LIST_NEW,
  DIS_CUS_TYPE_LIST,
  INTER_TAX_CAT_LIST
} from "../types";
import {
  RolesListApi,
  UsersListApi,
  acqSrcListApi,
  adminRolesApi,
  bnkNameListApi,
  buisnessTypeListApi,
  binLocationListApi,
  defaultBinLocationApi,
  searchBinLocationApi,
  catListApi,
  customerListApi,
  departmentListApi,
  disCusGrpListApi,
  disCusListApi,
  doctorListApi,
  imageUploadApi,
  itemGroupListApi,
  itemTypeListApi,
  manufacturesListApi,
  paymentMethodListApi,
  phoneListApi,
  pincodeListApi,
  gstSearchTaxpayerApi,
  manufacturerFuzzySearchApi,
  priceListApi,
  productDetailsApi,
  productListApi,
  schListApi,
  sectorListApi,
  shippingTypeListApi,
  stateListApi,
  storeIdApi,
  taxCatListApi,
  transactionPrintApi,
  transactionShareApi,
  uomGroupFindOneApi,
  uomGroupListApi,
  uomListApi,
  valListApi,
  vendorListApi,
  wareHouseListApi,
  cusTypeListApi,
  storeListApi,
  docListApi,
  adminRolesModApi,
  productBatchDetailsApi,
  storeStateListApi,
  storeDistrictListApi,
  storeCityListApi,
  storeSearchApi,
  storesItemApi,
  storesItemParamedApi,
  tableAlertApi,
  columnAlertApi,
  allUsersListApi,
  attachedRolesDepartmentListApi,
  getAddressApi,
  newWareHouseListApi,
  disCusCatListApi,
  disCusTypeListApi,
  interTaxCatListApi,
} from "../apis/general-api";
import { warehouseGetIdApi } from "../apis/inventory-api";
import { isAdmin } from "../config";

export function* getAddrssWorker(action) {
  try {
    const res = yield call(getAddressApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* productListWorker(action) {
  try {
    const res = yield call(productListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* productDetailsWorker(action) {
  try {
    const res = yield call(productDetailsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* productBatchDetailsWorker(action) {
  try {
    const res = yield call(productBatchDetailsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* phoneListWorker(action) {
  try {
    const res = yield call(phoneListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stateListWorker(action) {
  try {
    const res = yield call(stateListApi);
    const data = yield res.json();

    if (res.status === 200) {
      yield action.onSuccess(data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* storeStateListWorker(action) {
  try {
    const res = yield call(storeStateListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* storeDistrictListWorker(action) {
  try {
    const res = yield call(storeDistrictListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* storeCityListWorker(action) {
  try {
    const res = yield call(storeCityListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* storeSearchWorker(action) {
  try {
    const res = yield call(storeSearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* storesItemWorker(action) {
  try {
    const res = yield call(storesItemApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* storesItemParamedWorker(action) {
  try {
    // Store users exclude their own store; admins see every store
    let pos_id = "";
    if (!isAdmin) {
      const idRes = yield call(warehouseGetIdApi);
      pos_id = idRes?.data?.data?.pos_id ?? idRes?.data?.data?.warehouse_id;
    }
    const res = yield call(storesItemParamedApi, {
      ...action.data,
      excluded: !isAdmin,
      pos_id,
    });
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* doctorListWorker(action) {
  try {
    const res = yield call(doctorListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* storeIdWorker(action) {
  try {
    const res = yield call(storeIdApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* paymentMethodListWorker(action) {
  try {
    const res = yield call(paymentMethodListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* tableAlertWorker(action) {
  try {
    const res = yield call(tableAlertApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* allUsersListWorker(action) {
  try {
    const res = yield call(allUsersListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* columnAlertWorker(action) {
  try {
    const res = yield call(columnAlertApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* catListWorker(action) {
  try {
    const res = yield call(catListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uomListWorker(action) {
  try {
    const res = yield call(uomListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* priceListWorker(action) {
  try {
    const res = yield call(priceListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemGroupListWorker(action) {
  try {
    const res = yield call(itemGroupListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemTypeListWorker(action) {
  try {
    const res = yield call(itemTypeListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* taxCatListWorker(action) {
  try {
    const res = yield call(taxCatListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* interTaxCatListWorker(action) {
  try {
    const res = yield call(interTaxCatListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* manufacturesListWorker(action) {
  try {
    const res = yield call(manufacturesListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* shippingTypeListWorker(action) {
  try {
    const res = yield call(shippingTypeListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* sectorListWorker(action) {
  try {
    const res = yield call(sectorListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* schListWorker(action) {
  try {
    const res = yield call(schListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* vendorListWorker(action) {
  try {
    const res = yield call(vendorListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* valListWorker(action) {
  try {
    const res = yield call(valListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uomGroupListWorker(action) {
  try {
    const res = yield call(uomGroupListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uomGroupFindOneWorker(action) {
  try {
    const res = yield call(uomGroupFindOneApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* adminRolesWorker(action) {
  try {
    const res = yield call(adminRolesApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* adminRolesModWorker(action) {
  try {
    const res = yield call(adminRolesModApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* imageUploadWorker(action) {
  try {
    const formData = new FormData();
    formData.append("image", action?.data);
    const res = yield call(imageUploadApi, formData);

    // This backend answers 200 even on failure, with the outcome in the body,
    // and `filePath` was split before the status check — so a failed upload
    // threw a TypeError instead of reporting the error.
    const filePath = res?.data?.data;
    if (res?.status !== 200 || res?.data?.status === false || !filePath) {
      yield action.onError(res?.data);
      return;
    }

    // An absolute URL (object storage) is handed back whole; only a bare path
    // is reduced to its filename, which callers then prefix with the API host.
    const value = String(filePath);
    const isAbsolute = /^https?:\/\//i.test(value);
    const parts = value.split("/");
    yield action.onSuccess(isAbsolute ? value : parts[parts.length - 1]);
  } catch (error) {
    yield action.onError(error?.response);
  }
}


export function* departmentListWorker(action) {
  try {
    const res = yield call(departmentListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* rolesListWorker(action) {
  try {
    const res = yield call(RolesListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* attachedRolesDepartmentListWorker(action) {
  try {
    const res = yield call(attachedRolesDepartmentListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* docListWorker(action) {
  try {
    const res = yield call(docListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* usersListWorker(action) {
  try {
    const res = yield call(UsersListApi, action?.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* disCusListWorker(action) {
  try {
    const res = yield call(disCusListApi, action?.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* disCusGrpListWorker(action) {
  try {
    const res = yield call(disCusGrpListApi, action?.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* disCusCatListWorker(action) {
  try {
    const res = yield call(disCusCatListApi, action?.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* disCusTypeListWorker(action) {
  try {
    const res = yield call(disCusTypeListApi, action?.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* customerListWorker(action) {
  try {
    const res = yield call(customerListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* pincodeListWorker(action) {
  try {
    const res = yield call(pincodeListApi, action.data);
    const data = yield res.json();

    if (res.status === 200) {
      yield action.onSuccess(data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* gstSearchTaxpayerWorker(action) {
  try {
    const res = yield call(gstSearchTaxpayerApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* manufacturerFuzzySearchWorker(action) {
  try {
    const res = yield call(manufacturerFuzzySearchApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* binLocationListWorker(action) {
  try {
    const idRes = yield call(warehouseGetIdApi);
    const warehouse_id = idRes?.data?.data?.warehouse_id ?? idRes?.data?.data?.pos_id;
    const res = yield call(binLocationListApi, { warehouse_id });

    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* defaultBinLocationWorker(action) {
  try {
    const idRes = yield call(warehouseGetIdApi);
    const warehouse_id = idRes?.data?.data?.warehouse_id ?? idRes?.data?.data?.pos_id;
    const res = yield call(defaultBinLocationApi, {
      warehouse_id,
      field: action.data?.field,
    });

    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* searchBinLocationWorker(action) {
  try {
    // Callers that already know which warehouse they are working in (e.g. a
    // drop list, which is saved against its own warehouse_id) pass it in;
    // everyone else falls back to the warehouse of the current session.
    let warehouse_id = action.data?.warehouse_id;
    if (!warehouse_id) {
      const idRes = yield call(warehouseGetIdApi);
      warehouse_id = idRes?.data?.data?.warehouse_id ?? idRes?.data?.data?.pos_id;
    }
    const res = yield call(searchBinLocationApi, {
      warehouse_id,
      field: action.data?.field,
      value: action.data?.value,
    });

    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* wareHouseListWorker(action) {
  try {
    const res = yield call(wareHouseListApi);
    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* newWareHouseListWorker(action) {
  try {
    const res = yield call(newWareHouseListApi);
    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* storeListWorker(action) {
  try {
    const res = yield call(storeListApi);
    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* transactionShareWorker(action) {
  try {
    const res = yield call(transactionShareApi, action?.data);
    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* transactionPrintWorker(action) {
  try {
    const res = yield call(transactionPrintApi, action?.data);
    if (res.status === 200) {
      yield action.onSuccess(res?.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* acqSrcListWorker(action) {
  try {
    const res = yield call(acqSrcListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* buisnessTypeListWorker(action) {
  try {
    const res = yield call(buisnessTypeListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* bnkNameListWorker(action) {
  try {
    const res = yield call(bnkNameListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* cusTypeListWorker(action) {
  try {
    const res = yield call(cusTypeListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* storeListWatcher() {
  yield takeLatest(STORE_LIST, storeListWorker);
}

export function* wareHouseListWatcher() {
  yield takeLatest(WARE_HOUSE_LIST, wareHouseListWorker);
}

export function* newWareHouseListWatcher() {
  yield takeLatest(WARE_HOUSE_LIST_NEW, newWareHouseListWorker);
}
export function* binLocationListWatcher() {
  yield takeLatest(BIN_LOCATION_LIST, binLocationListWorker);
}
export function* defaultBinLocationWatcher() {
  yield takeLatest(DEFAULT_BIN_LOCATION, defaultBinLocationWorker);
}
export function* searchBinLocationWatcher() {
  yield takeLatest(SEARCH_BIN_LOCATION, searchBinLocationWorker);
}
export function* customerListWatcher() {
  yield takeLatest(CUSTOMER_LIST, customerListWorker);
}

export function* disCusGrpListWatcher() {
  yield takeLatest(DIS_CUS_GROUP_LIST, disCusGrpListWorker);
}
export function* disCusCatListWatcher() {
  yield takeLatest(DIS_CUS_CAT_LIST, disCusCatListWorker);
}
export function* disCusTypeListWatcher() {
  yield takeLatest(DIS_CUS_TYPE_LIST, disCusTypeListWorker);
}
export function* disCusListWatcher() {
  yield takeLatest(DIS_CUS_LIST, disCusListWorker);
}
export function* productListWatcher() {
  yield takeLatest(PRODUCT_LIST, productListWorker);
}
export function* getAddrssWatcher() {
  yield takeLatest(GET_ADDRSS, getAddrssWorker);
}
export function* productDetailsWatcher() {
  yield takeLatest(PRODUCT_DETAILS, productDetailsWorker);
}
export function* productBatchDetailsWatcher() {
  yield takeLatest(PRODUCT_BATCH_DETAILS, productBatchDetailsWorker);
}
export function* phoneListWatcher() {
  yield takeLatest(PHONE_LIST, phoneListWorker);
}

export function* stateListWatcher() {
  yield takeLatest(STATE_LIST, stateListWorker);
}

export function* storeStateListWatcher() {
  yield takeLatest(STORE_STATE_LIST, storeStateListWorker);
}
export function* storeDistrictListWatcher() {
  yield takeLatest(STORE_DISTRICT_LIST, storeDistrictListWorker);
}
export function* storeCityListWatcher() {
  yield takeLatest(STORE_CITY_LIST, storeCityListWorker);
}
export function* storeSearchWatcher() {
  yield takeLatest(STORE_SEARCH, storeSearchWorker);
}
export function* storesItemParamedWatcher() {
  yield takeLatest(STORE_ITEM_PARAMED, storesItemParamedWorker);
}
export function* storesItemWatcher() {
  yield takeLatest(STORE_ITEM, storesItemWorker);
}

export function* doctorListWatcher() {
  yield takeLatest(DOCTOR_LIST, doctorListWorker);
}
export function* storeIdWatcher() {
  yield takeLatest(STORE_ID, storeIdWorker);
}

export function* paymentMethodListWatcher() {
  yield takeLatest(PAYMENT_METHODS_LIST, paymentMethodListWorker);
}
export function* tableAlertWatcher() {
  yield takeLatest(TABLE_ALERT, tableAlertWorker);
}
export function* allUsersListWatcher() {
  yield takeLatest(ALL_USERS_LIST, allUsersListWorker);
}

export function* columnAlertWatcher() {
  yield takeLatest(COLUMN_ALERT, columnAlertWorker);
}

export function* catListWatcher() {
  yield takeLatest(CATEGORY_LIST, catListWorker);
}
export function* uomListWatcher() {
  yield takeLatest(UOM_LIST, uomListWorker);
}
export function* priceListWatcher() {
  yield takeLatest(PRICE_LIST, priceListWorker);
}
export function* itemGroupListWatcher() {
  yield takeLatest(ITEM_GROUP_LIST, itemGroupListWorker);
}
export function* itemTypeListWatcher() {
  yield takeLatest(ITEM_TYPE_DROP_DOWN, itemTypeListWorker);
}
export function* taxCatListWatcher() {
  yield takeLatest(TAX_CAT_LIST, taxCatListWorker);
}
export function* interTaxCatListWatcher() {
  yield takeLatest(INTER_TAX_CAT_LIST, interTaxCatListWorker);
}
export function* manufacturesListWatcher() {
  yield takeLatest(MANUFACTURERS_LIST, manufacturesListWorker);
}
export function* shippingTypeListWatcher() {
  yield takeLatest(SHIPPING_TYPE_LIST, shippingTypeListWorker);
}
export function* sectorListWatcher() {
  yield takeLatest(SECTOR_LIST, sectorListWorker);
}
export function* schListWatcher() {
  yield takeLatest(SCH_LIST, schListWorker);
}
export function* vendorListWatcher() {
  yield takeLatest(VENDOR_LIST, vendorListWorker);
}
export function* valListWatcher() {
  yield takeLatest(VALUATION_LIST, valListWorker);
}
export function* uomGroupListWatcher() {
  yield takeLatest(UOM_GROUP_LIST, uomGroupListWorker);
}
export function* uomGroupFindOneWatcher() {
  yield takeLatest(UOM_GROUP_FIND_ONE, uomGroupFindOneWorker);
}
export function* imageUploadWatcher() {
  yield takeLatest(IMAGE_UPLOAD, imageUploadWorker);
}
export function* adminRolesWatcher() {
  yield takeLatest(ADMIN_ROLES, adminRolesWorker);
}
export function* adminRolesModWatcher() {
  yield takeLatest(ADMIN_ROLES_MOD, adminRolesModWorker);
}
export function* departmentListWatcher() {
  yield takeLatest(DEPARTMENR_LIST, departmentListWorker);
}
export function* rolesListWatcher() {
  yield takeLatest(ROLES_LIST, rolesListWorker);
}
export function* attachedRolesDepartmentListWatcher() {
  yield takeLatest(
    ATTACHED_ROLES_DEPARTMENT_LIST,
    attachedRolesDepartmentListWorker
  );
}
export function* docListWatcher() {
  yield takeLatest(DOC_LIST, docListWorker);
}
export function* usersListWatcher() {
  yield takeLatest(USERS_LIST, usersListWorker);
}
export function* acqSrcListWatcher() {
  yield takeLatest(ACQ_SRC_LIST, acqSrcListWorker);
}
export function* buisnessTypeListWatcher() {
  yield takeLatest(BUISNESS_TYPE_LIST, buisnessTypeListWorker);
}
export function* bnkNameListWatcher() {
  yield takeLatest(BANK_NAME_LIST, bnkNameListWorker);
}
export function* cusTypeListWatcher() {
  yield takeLatest(CUSTOMER_TYPE_LIST, cusTypeListWorker);
}
export function* pincodeListWatcher() {
  yield takeLatest(PINCODE_LIST, pincodeListWorker);
}
export function* gstSearchTaxpayerWatcher() {
  yield takeLatest(GST_SEARCH_TAXPAYER, gstSearchTaxpayerWorker);
}
export function* manufacturerFuzzySearchWatcher() {
  yield takeLatest(MANUFACTURER_FUZZY_SEARCH, manufacturerFuzzySearchWorker);
}
export function* transactionShareWatcher() {
  yield takeLatest(TRANSACTION_SHARE, transactionShareWorker);
}
export function* transactionPrintWatcher() {
  yield takeLatest(TRANSACTION_PRINT, transactionPrintWorker);
}
